(function () {
    function initAceiiSocialEcosystem() {
      var sections = document.querySelectorAll('[data-aceii-social-system]');

      sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      var gallery = section.querySelector('[data-social-gallery]');
      var cards = section.querySelectorAll('[data-social-card]');
      var activeCard = null;
      var revealTimer = null;

      if (!gallery || !cards.length) return;

      function desktop() {
        return window.matchMedia('(min-width: 901px)').matches;
      }

      function showDetail(card) {
        clearTimeout(revealTimer);

        revealTimer = setTimeout(function () {
          if (activeCard === card) {
            card.classList.add('is-revealed');
          }
        }, 520);
      }

      function setActive(card) {
        if (!card || activeCard === card) return;

        clearTimeout(revealTimer);

        cards.forEach(function (item) {
          item.classList.remove('is-revealed');
        });

        activeCard = card;

        cards.forEach(function (item) {
          item.classList.toggle('is-active', item === card);
        });

        showDetail(card);
      }

      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          if (desktop()) setActive(card);
        });

        card.addEventListener('click', function () {
          setActive(card);
        });

        card.addEventListener('focus', function () {
          setActive(card);
        });
      });

      gallery.addEventListener('mouseleave', function () {
        if (desktop()) setActive(cards[0]);
      });

      setActive(cards[0]);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAceiiSocialEcosystem);
    } else {
      initAceiiSocialEcosystem();
    }

    document.addEventListener('shopify:section:load', initAceiiSocialEcosystem);
  })();
